import { Link } from "react-router-dom";

import Icon from "components/UI/IconSVG/Icon";

import "./MarketItem.scss";

const MarketItem = ({
  market,
  index,
  onClick,
  linkTo,
  isMobile,
  containerClassName,
  itemClassName,
  logoClassName,
  titleClassName,
  showArrow = false,
  isSelected = false,
}) => {

  const logoClass = isSelected
    ? `${logoClassName} ${logoClassName}-active`
    : `${logoClassName} ${logoClassName}-disabled`;

  const titleClass = isSelected
    ? `${titleClassName} ${titleClassName}-active`
    : `${titleClassName}`;

  return (
    <Link key={index} className={containerClassName} to={linkTo} onClick={() => {onClick(); if (isMobile) window.scrollTo(0, 0); }}>
      <div className={itemClassName}>
        <div className={`${itemClassName}-container`} style={isSelected ? { backgroundColor: "#FFE14B" } : {}}>
          <div className={`${logoClass}-container`}>
          {isSelected
              ? <Icon sprite="activities" name="check" width={24} height={24} />
              : <Icon name={market.icon} width={24} height={24} />
            }
          </div>
          <p className={titleClass}>{market.titlePlaces}</p>
        </div>
        {showArrow && <div className={`${itemClassName}-arrow`} />}
      </div>
    </Link>
  );
};

export default MarketItem;
